export default {"src":"/kaimono/_next/static/media/alert.41186c93.svg","height":36,"width":36};